/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The type of binding for the image build.
 */
export enum BindingType {
  BindingTypeEarly = 'early',
  BindingTypeLate = 'late',
}
